import React from 'react';
import { AnimationLoader, LoaderContainer, LoaderElement } from './index.elements';
import theme from 'themes';
import styled from 'styled-components';

type LoaderProps = {
  padding?: string;
  size?: string;
  color?: string; // color props should be in hexadecimal with length of six.
  thickness?: string;
  animated?: boolean;
  progressText?: string;
  squareLoader?: boolean;
};

const AnimationLoaderContainer = styled.div`
  position: relative;
`;
const CenterText = styled.div`
  position: absolute;
  left: calc(50% - 16px);
  top: calc(50% - 12px);
  font-size: 13px;
  text-align: center;
  width: 36px;
`;

const SquareLoaderGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3px;
`;

const SquareLoaderElement = styled.div`
  height: 20px;
  width: 20px;
  background: #0076cc;
  animation: flash_1 1.5s ease-in-out 1.5s infinite;

  &:nth-child(2) {
    animation-delay: 0.75s;
    background-color: ${theme.colors.darkBlue2};
  }
  &:nth-child(3) {
    animation-delay: 0.75s;
    background-color: ${theme.colors.darkBlue2};
  }
  @keyframes flash_1 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

const CustomLoader = ({
  padding,
  size = '5rem',
  color = theme.colors.darkBlue3,
  thickness,
  animated,
  progressText = '',
  squareLoader = false
}: LoaderProps): JSX.Element => {
  return (
    <LoaderContainer padding={padding}>
      {animated ? (
        squareLoader ? (
          <SquareLoaderGroup>
            <SquareLoaderElement />
            <SquareLoaderElement />
            <SquareLoaderElement />
            <SquareLoaderElement />
          </SquareLoaderGroup>
        ) : (
          <AnimationLoaderContainer>
            <AnimationLoader />
            <CenterText>{progressText}</CenterText>
          </AnimationLoaderContainer>
        )
      ) : (
        <LoaderElement thickness={thickness} size={size} color={color} />
      )}
    </LoaderContainer>
  );
};

export default CustomLoader;
